<script lang="ts">
  import {todoAllmark,allTodoList} from "../../../store"
  import {tododata} from "../../../Data/Todo/Todo"
  import { toasts } from 'svelte-toasts';
  let setAlltodoList:any
  allTodoList.subscribe((value) => {
    setAlltodoList = value
  })
  let setTodoAllmark:boolean
  let IsStrike = [];
  allTodoList.update(value => value = tododata);
  todoAllmark.subscribe((value)=>{
    setTodoAllmark = value
  })
  const deleteTodo = (data:string) => {
    allTodoList.update(value => value = setAlltodoList.filter((el) => el !== data));
    toasts.success({
          description: 'Deleted Task !',
          placement: 'top-right',
    });
  };
  $: isCompleted = (value:string) => {
    if (IsStrike.includes(value)) {
      IsStrike = IsStrike.filter((elem) => elem !== value);
      toasts.error({
          description: 'Task In-Completed !',
          placement: 'top-right',
      } );
    } else {
      IsStrike = [...IsStrike, value];
      toasts.success({
          description: 'Task Completed !',
          placement: 'top-right',
      });
    }
  };
</script>
<div class="todo-list-body">
  <ul id="todo-list">
    {#each setAlltodoList as todoItem}
      <li class="task {setTodoAllmark || IsStrike.includes(todoItem) ? "completed" : ""}">
        <div class="task-container">
          <h4 class="task-label">{todoItem} </h4>
          <span class="task-action-btn">
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span class="action-box large delete-btn" title="Delete Task" on:click={() => deleteTodo(todoItem)}>
              <i class="icon"><i class="icon-trash"></i></i>
            </span>
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span class="action-box large complete-btn" title="Mark Complete" on:click={() => isCompleted(todoItem)}>
              <i class="icon"><i class="icon-check"></i></i>
            </span>
          </span>
        </div>
      </li>
    {/each}
  </ul>
</div>